export enum PromocodeTypeConstants {
    type1 = 1,
    type2 = 2,
    type3 = 3,
}